<template>
  <div class="plus-poker" :class="{collapsed: collapsed}" v-on:click="handleUncollapse">
    +
  </div>
</template>

<script>
export default {
  props:{
    collapsed: Boolean
  },
  methods: {
    handleUncollapse() {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.plus-poker{
  display:inline-block;
  background-color:rgba(255,255,255,0.9);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  color:#666;
  position:absolute;
  z-index:40;
  bottom:0;
  padding:2px 8px;
  right: 245px;
  box-sizing: border-box;
  cursor:pointer;
  user-select: none;
  font-size:21px;
  transform:translateY(100%);
  transition:all 0.7s ease;
}

.plus-poker.collapsed{
  transform:translate(0);
}
</style>